<template>
    <div id="wdc-app" class="wdc-app">
        <router-view class="view" :style="{ paddingBottom: showTabbar ? '60px' : '0' }" />
        <!-- 模版底部导航 -->
        <div class="tabbar-box" v-if="pageEndSetting == 1 && isHiddenTab" style="position: fixed; bottom: 0px; width: 100%; z-index: 9999999">
            <modularTabbar :dataS="tempObj"></modularTabbar>
        </div>
    </div>
</template>

<script>
// 定制化模版tabbar
import modularTabbar from './view/modularTabbar/modularTabbar' 
export default {
    data() {
        return {
            active: '',
            isHiddenTab: false,
            tempObj: {}, // 底部导航数据
            hasTableArr: [],
            pageEndSetting: null, // 模版底部导是否显示 1 显示 2 不显示
            showTabbarList: ['/homepage','/goodsList', '/learning', '/saccount',], // 页面需要显示tabber
        }
    },
    watch: {
        $route(val) {
            this.active = val.path
            this.initFootData()
            if (this.hasTableArr.includes(this.$route.path)) {
                this.isHiddenTab = true
            } else {
                this.isHiddenTab = false
            }
        },
    },
    computed: {
        showTabbar() {
            let isShow1 = this.$route.meta && this.$route.meta.showTabbar
            let isShow2 = this.$route.path && this.showTabbarList.includes(this.$route.path)
            return isShow1 || isShow2
        },
        rootContent() {
            return {
                paddingBottom: this.pageHeaderSetting == 1 ? '10px' : '',
                paddingTop: this.pageEndSetting == 1 && this.tempHeaderObj.topFixed && this.tempHeaderObj.showHeader ? '35px' : '',
            }
        },
    },
    components: { modularTabbar },
    created() {
        this.initFootData()
    },
    mounted() {},
    methods: {
        // 初始化可视化自定义footer
        initFootData() {
            let pageEndOBJ = JSON.parse(localStorage.getItem('setTempConfigs'))

            if (!pageEndOBJ || pageEndOBJ.pageEnd == null) return

            this.isRender = true
            pageEndOBJ.pageEnd.token = localStorage.getItem('token')
            this.pageEndSetting = pageEndOBJ.pageEndSetting
            this.tempObj = pageEndOBJ.pageEnd
            this.tempObj.token = localStorage.getItem('token')
            this.tempObj.selectId = localStorage.getItem('selectMenuId')

            let tempMenuList = pageEndOBJ.pageUrlList
            let tarBarUrl = []
            if (tempMenuList.length > 0) {
                tempMenuList.forEach((item, index) => {
                    if (item.uri) {
                        tarBarUrl.push(item.uri)
                    }
                    if (item.manualUrl) {
                        tarBarUrl.push(item.manualUrl)
                    }
                })
                // tarBarUrl.push('/')
                let menuList = pageEndOBJ.pageEnd.menuList
                if (menuList.length > 0) {
                    menuList.forEach((item, index) => {
                        if (item.url) {
                            tarBarUrl.push(item.url)
                        }
                    })
                }
                this.hasTableArr = [...new Set(tarBarUrl)]
                this.pathStr = window.location.pathname
            }
        },
    },
}
</script>

<style lang="stylus">
html, body, .wdc-app {
  height: 100%;
}

.view {
    box-sizing border-box
    // padding-bottom 50PX
}

.van-notify--danger {
  background-color: #ee0a24 !important;
}

.van-tabbar--fixed {
  padding-bottom: 10px;
  position: fixed !important;
  bottom: 0;
  left: 0;
}

.van-tabbar-item__text {
  text-align: center;
}

.nav-icon {
  width: 44px;
  margin-bottom:4px;
}

input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
  -webkit-text-fill-color: #333;
}

input[type=text]:focus, input[type=password]:focus, textarea:focus {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}
</style>
